<template>
  <!-- 实名认证弹窗 -->
  <div v-if="isshow" class="modal-overlay">
    <div class="modal-content">
      <div class="modal-header">
        <h2>{{ $t('_sz._smrz') }}</h2>
        <button class="close-btn" @click="close">×</button>
      </div>

      <div class="modal-body">
        <form @submit.prevent="onFinish">
          <div class="form-group rzlx">
            <label>{{ $t('_sz._rzlx') }}</label>
            <a-radio-group v-model:value="auth.type" :options="plainOptions" :disabled="!isAllow" />
          </div>

          <template v-if="auth.type == 1">
            <div class="form-group">
              <label>{{ $t('_sz._sfzzm') }}</label>
              <upload-file @onUpload="onFrontUpload" :imageUrl="imageFrontUrl" :disabled="!isAllow"></upload-file>
            </div>
            <div class="form-group">
              <label>{{ $t('_sz._sfzfm') }}</label>
              <upload-file @onUpload="onBackUpload" :imageUrl="imageBackUrl" :disabled="!isAllow"></upload-file>
            </div>
            <div class="form-group">
              <label>{{ $t('_sz._zsxm') }}</label>
              <input v-model="auth.name" type="text" required :placeholder="$t('_sz._qsrzsxm')" :disabled="!isAllow" />
            </div>

            <div class="form-group">
              <label>{{ $t('_sz._sfzhm') }}</label>
              <input v-model="auth.card" type="text" required :placeholder="$t('_sz._qsrsfzhm')" :disabled="!isAllow" />
            </div>
          </template>
          <template v-if="auth.type == 2">
            <div class="form-group">
              <label>{{ $t('_sz._yyzz') }}</label>
              <upload-file @onUpload="onCompanyUpload" :imageUrl="imageCompanyUrl" :disabled="!isAllow"></upload-file>
            </div>
            <div class="form-group">
              <label>{{ $t('_sz._qymc') }}</label>
              <input v-model="auth.company" type="text" required :placeholder="$t('_sz._qsrqymc')" :disabled="!isAllow" />
            </div>
            <div class="form-group">
              <label>{{ $t('_sz._yyzzh') }}</label>
              <input v-model="auth.card" type="text" required :placeholder="$t('_sz._qsryyzzh')" :disabled="!isAllow" />
            </div>
          </template>

          <template v-if="auth.status > 0">
            <div class="form-group">
              <label>{{ $t('_sz._zt') }}</label>
              <div v-if="auth.status == 1">
                <a-tag color="orange">{{ $t('_sz._shz') }}</a-tag>
              </div>
              <div v-if="auth.status == 2">
                <a-tag color="green">{{ $t('_sz._ytg') }}</a-tag>
              </div>
              <div v-if="auth.status == 3">
                <a-tag color="red">{{ $t('_sz._ybh') }}</a-tag>
              </div>
            </div>
          </template>

          <div class="form-actions" v-if="isAllow">
            <button type="button" class="cancel-btn" @click="close">{{ $t('_sz._qx') }}</button>
            <button type="submit" class="submit-btn">{{ $t('_sz._tjrz') }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import UploadFile from '@/components/UploadFile.vue'
export default {
  name: 'AuthBox',
  components: { UploadFile },
  data() {
    return {
      isshow: false,
      isAllow: true,
      plainOptions: [
        { label: this.$t('_sz._gr'), value: 1 },
        { label: this.$t('_sz._qy'), value: 2 }
      ],
      //店铺信息
      btnLoad: false,
      auth: {
        type: 1,
        name: '',
        card: '',
        company: ''
      },

      imageFrontUrl: '',
      imgFront: '',

      imageBackUrl: '',
      imgBack: '',

      imageCompanyUrl: '',
      imgCompany: ''
    }
  },
  created() {},
  methods: {
    show() {
      this.isshow = true
      this.$nextTick(function () {
        //获取信息
        this.getStoreAuth()
      })
    },
    close() {
      this.isshow = false
      this.imageFrontUrl = ''
      this.imageBackUrl = ''
      this.imageCompanyUrl = ''
    },
    getStoreAuth() {
      const that = this
      this.$api.user.getUserAuth().then((res) => {
        if (!res.data) {
          return
        }

        that.auth = res.data
        if (that.auth.status == 1 || that.auth.status == 2) {
          //不允许访问
          that.isAllow = false
        } else {
          //允许访问
          that.isAllow = true
        }

        that.imageFrontUrl = res.data.front
        that.imageBackUrl = res.data.back
        that.imageCompanyUrl = res.data.license
      })
    },
    /**------------------------------
     * 保存个人信息
     * @param {*} values
     */
    onFinish() {
      if (this.btnLoad) {
        return
      }
      this.btnLoad = true

      this.auth.front = ''
      this.auth.back = ''
      this.auth.license = ''
      if (this.auth.type == 1) {
        this.auth.front = this.imgFront
        this.auth.back = this.imgBack
      } else if (this.auth.type == 2) {
        this.auth.license = this.imgCompany
      }

      console.log('params:', this.auth)

      let that = this
      this.$message.loading({ content: this.$t('_a._bcz'), key: 'msg' })
      this.$api.user.saveAuth(this.auth).then((res) => {
        that.btnLoad = false
        if (res.code == 1) {
          that.$message.warning({ content: res.msg, key: 'msg' })
        } else {
          that.$message.success({ content: res.msg, key: 'msg' })
          that.getStoreAuth()
        }
      })
    },
    onFinishFailed(errorInfo) {
      console.log('Failed:', errorInfo)
    },
    onFrontUpload(img) {
      this.imageFrontUrl = img
      this.imgFront = img
    },
    onBackUpload(img) {
      this.imageBackUrl = img
      this.imgBack = img
    },
    onCompanyUpload(img) {
      this.imageCompanyUrl = img
      this.imgCompany = img
    }
  }
}
</script>

<style scoped>
@import url('../../static/css_setting/1.css');
</style>
<style scoped>
.rzlx >>> .ant-radio-group {
  display: flex !important;
}
</style>
